var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_2777_3290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3026 10.9981C8.41304 13.3209 4.52344 19.515 4.52344 29.5804C4.52344 39.6459 20.0818 62.8738 34.8623 59.0025C46.5311 55.1312 53.5324 43.5172 51.9766 28.0319C50.4207 12.5466 46.5311 9.44956 41.8636 10.2238C37.1961 10.9981 32.5286 11.7724 28.639 11.7724C24.7494 10.9981 19.3039 6.3525 12.3026 10.9981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3539 11.0839L12.354 11.084L12.3579 11.0814C15.8306 8.77718 18.9122 8.77766 21.6135 9.44982C22.9671 9.78662 24.225 10.2921 25.3926 10.7642L25.45 10.7874C26.592 11.2492 27.652 11.6779 28.6194 11.8704L28.6291 11.8724H28.639C32.5368 11.8724 37.2108 11.097 41.8736 10.3235L41.88 10.3225C43.0341 10.131 44.1327 10.18 45.1565 10.5948C46.1799 11.0093 47.1376 11.7929 48.0039 13.0862C49.7397 15.6777 51.0995 20.3022 51.8771 28.0419C53.4292 43.4898 46.4471 55.0521 34.8339 58.9066C27.5035 60.8246 19.9568 56.0265 14.2256 49.452C11.363 46.1683 8.96127 42.4498 7.27559 38.9253C5.58885 35.3985 4.62344 32.0753 4.62344 29.5804C4.62344 19.5378 8.50387 13.3831 12.3539 11.0839Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3290",
    x: 0.523438,
    y: 0.960938,
    width: 55.6719,
    height: 58.4727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3290",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth36);
export default __webpack_public_path__ + "static/media/teeth36.07bac3b7a2bb7269c457df6d87e4bdfb.svg";
export { ForwardRef as ReactComponent };